import CropperComponent from "@/components/Shared/Cropper";
import { mapGetters } from "vuex";
import * as types from "@/store/types";
export default {
  name: "attachment",
  props: {
    title: {
      type: String
    },
    height: {
      type: Number,
      default: 250
    },
    previewHeight: {
      type: Number,
      default: 250
    }
  },
  components: {
    CropperComponent
  },
  data() {
    return {
      file: undefined,
      fileRules: "",
      url: null,
      isModalOpen: false,
      imageViewerModal: false
    };
  },
  computed: {
    ...mapGetters({
      initData: types.init.getters.GET_INIT_DATA,
      userVerifyInfo: types.userVerifyInfo.getters.GET_USER_VERIFY_INFO
    })
  },
  methods: {
    uploadImage() {
      this.url = URL.createObjectURL(this.file);
    },
    editImage() {
      this.$refs.cropModal.openEditModal();
    },
    onGetImage(data) {
      this.url = URL.createObjectURL(data);
      this.$emit("pushFileUp", data);
    },
    deleteImage() {
      this.url = null;
      this.file = null;
      this.fileRules = "";
    }
  },
  watch: {
    file(newFile) {
      if (newFile) {
        const maxSize = this.initData.kyc.image.maximum_file_size;
        const minSize = this.initData.kyc.image.minimum_file_size;
        const fileSize = newFile.size / 1000;
        const isJpeg = newFile.type === "image/jpeg";
        const isPng = newFile.type === "image/png";
        if (!isPng && !isJpeg) {
          this.$emit("pushFileUp", newFile);
          this.fileRules = this.$t(
            "ticketsPage.createTicket.attachment.fileFormatIsNotCorrect"
          );
        } else if (fileSize > maxSize) {
          this.fileRules = this.$t(
            "ticketsPage.createTicket.attachment.moreThanMaxSize",
            { count: this.initData.kyc.image.maximum_file_size / 1000 }
          );
          this.$emit("pushFileUp", newFile);
        } else if (fileSize < minSize) {
          this.fileRules = this.$t(
            "ticketsPage.createTicket.attachment.lessThanMinSize",
            { count: this.initData.kyc.image.minimum_file_size / 1000 }
          );
          this.$emit("pushFileUp", newFile);
        } else {
          this.$emit("pushFileUp", newFile);
          this.fileRules = "";
        }
      } else {
        this.$emit("pushFileUp", null);
      }
    }
  }
};
